<template>
  <header></header>

  <main>
    <BackHome />
    <div class="container animated">
      <router-view />
      <Comments v-if="route.path !== '/'" />
    </div>
  </main>

  <footer>
    <MainNotification />
  </footer>
  <VersionChecker />
  <EnablePush />

  <Waves />
</template>
<script setup>
  import { onMounted, watch, computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useHead } from '@vueuse/head'

  import MainNotification from './components/Parts/MainNotification.vue'
  import Waves from './components/Parts/Waves.vue'
  import MainMenu from './components/MainMenu.vue'
  import BackHome from './components/Parts/MenuButton.vue'

  import { useAuthStore, VersionChecker } from 'shared-vue'
  import { Comments, EnablePush, patchFetch } from 'shared-vue'

  // Custom fetch override
  patchFetch();


  // Stores and route
  const route = useRoute()
  const authStore = useAuthStore()
  const user = computed(() => authStore.user)

  const isAdmin = computed(() => user.value?.roles?.includes('Admin'))

  const canonicalUrl = computed(() => {
    return window.location.origin + route.path
  })

  // Load current user on mount
  onMounted(() => {
    authStore.fetchUser()
  })
  const headEntry = useHead({
    title: '',
    meta: [],
    link: []
  })
  //onMounted(updateMeta)
  watch(
    () => route.fullPath,
    () => {
      var routeName = route.name ?? 'Home';
      const title = `${routeName} - Skillvolution`
      const description =
        route.meta.description ||
        'From speedrunning world records to game development and tech builds, explore insights on gaming strategies, programming, and high-performance hardware.'

      headEntry.patch({
        title,
        meta: [
          { name: 'description', content: description },
          { property: 'og:type', content: 'website' },
          { property: 'og:title', content: title },
          { property: 'og:description', content: description },
          { property: 'og:url', content: window.location.href },
          { property: 'og:image', content: `${window.location.origin}/assets/me.png` }
        ],
        link: [{ rel: 'canonical', href: window.location.href }]
      })
    },
    { immediate: true }
  )

</script>
